import BaseAPI from '../BaseAPI.js'

export default class extends BaseAPI {
  _resource ='navigation'
  _parentResources =['app']
}
